import React from 'react';
import { motion } from 'framer-motion';
import { Gift, FileText, Bot, Scale, Users, CheckSquare } from 'lucide-react';
const bonuses = [{
  icon: <FileText className="w-7 h-7" data-id="element-57" data-mp="pj6c83lngiqh" />,
  n: 'Bono 1',
  title: 'Biblioteca Profesional de Modelos Jurídicos',
  desc: 'Más de 500 modelos editables de escritos, contratos, recursos, cautelares, intimaciones y documentación profesional.',
  value: '$89.990'
}, {
  icon: <Bot className="w-7 h-7" data-id="element-58" data-mp="1tlufo18fris" />,
  n: 'Bono 2',
  title: 'Sistema Completo de IA Jurídica',
  desc: '100 prompts jurídicos profesionales, automatizaciones y herramientas para abogados.',
  value: '$69.990'
}, {
  icon: <Scale className="w-7 h-7" data-id="element-59" data-mp="3o3ptu3kvq2xz" />,
  n: 'Bono 3',
  title: 'Biblioteca de Jurisprudencia y Estrategias Procesales',
  desc: 'Fallos clave, argumentos listos para adaptar y estrategias de litigación.',
  value: '$59.990'
}, {
  icon: <Users className="w-7 h-7" data-id="element-60" data-mp="1r9uwp1l7048c" />,
  n: 'Bono 4',
  title: 'Kit Profesional de Gestión y Conversión de Clientes',
  desc: 'Marketing jurídico, seguimiento de consultas, presupuestos y sistemas de captación.',
  value: '$49.990'
}, {
  icon: <CheckSquare className="w-7 h-7" data-id="element-61" data-mp="3dd90x847rdvr" />,
  n: 'Bono 5',
  title: 'Mega Kit de Checklists y Herramientas del Estudio',
  desc: 'Calculadoras, planillas, protocolos y sistemas de organización profesional.',
  value: '$39.990'
}];
export const Bonuses = () => {
  return <section className="py-12 bg-legal-900" data-id="element-62" data-mp="2zg3x7erz2r3o">
      <div className="container mx-auto px-4" data-id="element-63" data-mp="2ugr0817e03nd">
        <div className="text-center mb-16 max-w-2xl mx-auto" data-id="element-64" data-mp="2uhsl0xe7g4ia">
          <span className="inline-flex items-center gap-2 text-gold-500 font-semibold tracking-widest uppercase text-sm mb-4" data-id="element-65" data-mp="38gs13gnnjb2u">
            <Gift className="w-4 h-4" data-id="element-66" data-mp="33ge3ytnl9ljl" />
            Bonos premium
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-67" data-mp="np8buj9azfkb">
            Además, te llevás 5 bonos premium sin costo
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-68" data-mp="itavicy1i97j">
            Herramientas listas para usar que aceleran tu trabajo desde el
            primer caso.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12" data-id="element-69" data-mp="3hg6d3vd73d28">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="relative bg-legal-800 border border-gold-500/30 rounded-xl p-7 flex flex-col hover:border-gold-500/60 transition-colors" data-id="element-70" data-mp="3qipc24dv15j7" data-mpi={idx}>
              <span className="absolute -top-3 left-6 bg-gold-500 text-legal-900 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-71" data-mp="2a2d1707oc5se">
                {bonus.n}
              </span>

              <div className="mb-5 mt-2 flex items-center justify-center w-14 h-14 rounded-lg bg-gold-500/10 text-gold-500" data-id="element-72" data-mp="27hx5p0ida041">
                {bonus.icon}
              </div>

              <h3 className="text-lg font-bold text-white mb-3 leading-snug" data-id="element-73" data-mp="1xk8z9dbef461">
                {bonus.title}
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6 flex-1" data-id="element-74" data-mp="1tmbcsi90iw6c">
                {bonus.desc}
              </p>

              <div className="flex items-center justify-between border-t border-legal-700 pt-4" data-id="element-75" data-mp="1jup2co4i114n">
                <span className="text-sm text-slate-400" data-id="element-76" data-mp="1evc6xezkalqg">Valor</span>
                <span className="font-bold text-white line-through decoration-gold-500/70 decoration-2" data-id="element-77" data-mp="1evlz9982x4zb">
                  {bonus.value}
                </span>
              </div>
            </motion.div>)}
        </div>

        {/* Value stack */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="max-w-xl mx-auto text-center bg-legal-800 border border-legal-700 rounded-2xl p-6" data-id="element-78" data-mp="10vb43tzql48c">
          <p className="text-slate-400 mb-1" data-id="element-79" data-mp="2w5sxnzx8chev">Valor total de los bonos</p>
          <p className="font-serif text-3xl font-bold text-white" data-id="element-80" data-mp="2h9bn3awv76td">
            <span className="line-through decoration-gold-500 decoration-2 text-slate-500" data-id="element-81" data-mp="2hc6751byupm9">
              $309.950
            </span>{' '}
            <span className="text-gold-500" data-id="element-82" data-mp="289x0imjtjge5">incluidos hoy</span>
          </p>
          <p className="text-sm text-slate-400 mt-2" data-id="element-83" data-mp="2d7yewu6aurja">
            Los 5 bonos están incluidos sin cargo al adquirir el Megapack.
          </p>
        </motion.div>
      </div>
    </section>;
};